interface DiscountIconProps {
  className?: string;
}

export function DiscountIcon({className}: DiscountIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_159_27078)">
        <path
          d="M9.92857 1.5H8.23441C7.3609 1.5 6.525 1.85551 5.9191 2.48472L1.81274 6.74902C1.08376 7.50603 1.09509 8.70734 1.83822 9.45046L4.77257 12.3848C5.39185 13.0041 6.39293 13.0135 7.02378 12.4061L11.7122 7.89125C12.2156 7.40653 12.5 6.73782 12.5 6.039V4.07143C12.5 2.65127 11.3487 1.5 9.92857 1.5Z"
          stroke="#5433EB"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <ellipse cx="9.5" cy="4.5" rx="0.75" ry="0.75" fill="#5433EB" />
      </g>
      <defs>
        <clipPath id="clip0_159_27078">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
